/** Public sitename for SERP / JSON-LD / og:site_name (keep aligned with scripts/lib/structured-data-lib.cjs). */
export const SITE_PUBLIC_NAME = 'Assistance et dépannage vidéo';

export const COMPANY = {
  name: 'LEAGORA',
  legalForm: 'SAS',
  legalName: 'LEAGORA SAS',
  capital: '5 300 €',
  address: '36 rue Polonceau, 75018 Paris, France',
  siren: '952 380 764',
  siret: '952 380 764 00011',
  rcs: 'Paris 952 380 764',
  vat: 'FR29952380764',
  director: 'Matthieu NEVEUX',
  email: 'contact@leagora.fr',
  siteUrl: 'https://assistance-video.fr',
  siteName: 'Assistance Video',
};

export const HOSTING = {
  name: 'OVH SAS',
  address: '2 rue Kellermann, 59100 Roubaix, France',
  rcs: 'Lille Métropole 424 761 419',
  website: 'https://www.ovhcloud.com',
  websiteLabel: 'https://www.ovhcloud.com',
};

export const MEDIATOR = {
  name: 'CM2C — Centre de la Médiation de la Consommation de Conciliateurs de Justice',
  address: '49 rue de Ponthieu, 75008 Paris, France',
  phone: '01 89 47 00 14',
  email: 'cm2c@cm2c.net',
  website: 'https://www.cm2c.net',
  websiteLabel: 'www.cm2c.net',
};

export const LEGAL_FOOTER_COPYRIGHT = `© ${new Date().getFullYear()} Assistance Video - LEAGORA - Tous droits réservés`;
